export default "__VITE_ASSET__7f5dfe38__"